export default __webpack_public_path__ + "static/media/home-owner.e7b0f92b.svg";